import React from "react";
import { appMenu } from "routes/routeSetup";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Footer from "components/Layout/Footer";
import { useBreakpoint } from "components/Breakpoint";

import { useLocale, useStep } from "routes/LayoutContext";

import { LanguageModal } from "components/SetupModal";
import options from "utils/options";
import classNames from "classnames/bind";
import styles from "./SideMenu.module.scss";
import { SymbolList } from "components/Currencies";
import Affix from "@uiw/react-affix";

var cx = classNames.bind(styles);

const SideMenu = (props) => {
  const { className, ...restProps } = props;
  const breakpoints = useBreakpoint();
  const locale = useLocale();
  const languageModalRef = React.useRef(null);

  const step = useStep();

  const {
    app: {
      basicData: { AccountType },
    },
  } = useSelector((state) => state);

  const menuList = appMenu(locale, AccountType === "Commercial" ? 1 : 0);
  const openLanguageModal = () => {
    languageModalRef.current.open();
  };
  const { formatMessage: f } = useIntl();
  const getLanguageLabel = () => {
    return options.LanguageList.find((language) => language.value === locale)
      .label;
  };

  return (
    <div className={cx("sideMenu", restProps)} {...restProps}>
      <div>
        <div className={cx("logo")}>
          {breakpoints.md ? (
            <img
              src={require("assets/images/left_bg_logo_gray.png")}
              alt="UNI Logo"
            />
          ) : (
            <img
              src={require("assets/images/logo-white.png")}
              alt="UNI Logo"
              className={cx("logoUNI")}
            />
          )}
        </div>
      </div>
      <div className={cx("linkBlock")}>
        <div className={cx("sideContext")}>
          <h2>{f({ id: "Section.SideMenu.Welcome.Title" })}</h2>
          <p>{f({ id: "Section.SideMenu.Welcome.Label" })}</p>
        </div>
        <nav className={cx("navigator")}>
          {menuList.map((menu, idx) => {
            const menuNameId =
              AccountType === "Commercial"
                ? "Section.SideMenu.Commercial.Steps." + (idx + 1) + ".Label"
                : "Section.SideMenu.Retail.Steps." + (idx + 1) + ".Label";

            return (
              <Link
                to={menu.path}
                className={cx("link", {
                  active: step === idx,
                })}
                key={idx}
                onClick={(e) => {
                  if (menu.disable) {
                    e.preventDefault();
                  }
                }}
              >
                <span>
                  <img
                    src={require(`assets/images/progress/${menu.img}_${
                      step === idx ? "enable" : "disable"
                    }.png`)}
                    alt="icon"
                  />
                </span>
                <span className={cx("text")}>
                  <h4>
                    {f({ id: "Section.SideMenu.Progress.Label" })} {idx + 1}
                  </h4>
                  <h3>{f({ id: menuNameId })}</h3>
                </span>
              </Link>
            );
          })}
        </nav>
        <Affix offsetBottom={10}>
          <div className={cx("navFooter")}>
            {/* <div className={cx("navFooterBtn")}>
            <h5>Currencies</h5>
            <span>
              TWD
            </span>
          </div> */}
            <div className={cx("navFooterBtn")} onClick={openLanguageModal}>
              <h5>Language</h5>
              <span>
                <SymbolList symbol={"global_white"} size="14px" />
                <span>{getLanguageLabel()}</span>
              </span>
            </div>
            <LanguageModal ref={languageModalRef} />
            <Footer />
          </div>
        </Affix>
      </div>
    </div>
  );
};

export default SideMenu;
